export { default as CargasTancada } from "./CargasTancada";

